import { WOODLAND_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/woodlandBackdrops';
import { forestBiome } from '../biomeArchetypes';
import { OPENING_ROUTE_DEPTH_BACKDROPS, OPENING_ROUTE_DEPTH_HEIGHTS } from '../../../game/effects/atmosphere/silhouettes/openingRouteDepthBackdrops';

/** first_field — restrained moonlit starter field.
 *
 * The starter on-ramp field was pulling the heavy `meadow` preset and tripping
 * client_freeze events on modest screens (103-111 tick listeners, 87-94 tween
 * steps/frame). This preset stays sparse but no longer snaps the intro back to
 * daylight: cold moonlight, bruised clouds, low ground haze, and near-black
 * ridges make the harmless pigs feel a little wrong without hiding combat.
 */
export const FIRST_FIELD = forestBiome({
  id: 'first_field',
  sky: { from: 0x071126, to: 0x26324d, bands: 6 },
  celestial: { atX: 0.72, atY: 0.14, color: 0xc9d8ff, haloColor: 0x8197ca, size: 62, haloScale: 3, coreAlpha: 0.76, haloAlpha: 0.13, bodyType: 'moon', moonPhase: 'crescent' },
  cloudBands: { count: 3, color: 0x626a80, sizeMin: 420, sizeMax: 760, alphaMin: 0.06, alphaMax: 0.14, driftPxPerSec: 5, bandYMin: 0.06, bandYMax: 0.32 },
  motes: { colors: [0xb9caff, 0x9dba72], count: 6, sizeMin: 2, sizeMax: 5, driftPx: 28, periodMinMs: 9000, periodMaxMs: 16000, alphaMin: 0.12, alphaMax: 0.38 },
  rays: { color: 0x9fb5e8, count: 1, widthMin: 90, widthMax: 150, height: 460, tiltDeg: -6, periodMinMs: 16000, periodMaxMs: 24000, alphaMin: 0.03, alphaMax: 0.09 },
  glow: {
    blobs: [
      { color: 0x7188be, atX: 0.72, atY: 0.13, size: 260, alpha: 0.06 },
      { color: 0x53663c, atX: 0.48, atY: 0.94, size: 420, alpha: 0.05 },
    ],
    breathe: { periodMs: 9000, min: 0.82, max: 1.08 },
  },
  lightField: { palette: [0x8197ca, 0x667b4c], count: 3, sizeMin: 80, sizeMax: 160, alphaMin: 0.02, alphaMax: 0.06, driftRadius: 42, periodMinMs: 14000, periodMaxMs: 22000 },
  weather: {
    mode: 'fall',
    color: 0x8994ab,
    colorEnd: 0x455069,
    size: 3,
    frequencyMs: 850,
    lifespanMs: 3000,
    speed: 12,
    gravityY: 3,
    windX: 28,
    alphaEnd: 0.2,
    gust: { periodMs: 11000, min: 0.55, max: 1.15, phase: 0.3 },
  },
  parallax: [
    { svg: OPENING_ROUTE_DEPTH_BACKDROPS.firstField, shape: 'dunes', color: 0x263145, speed: 0.04, height: OPENING_ROUTE_DEPTH_HEIGHTS.firstField, alpha: 0.58, detail: 0.45, sway: { ampPx: 6, periodMs: 40000 }, occludeCelestial: true },
    { svg: WOODLAND_BACKDROPS.meadow.mid, shape: 'dunes', color: 0x19283a, speed: 0.10, height: 240, alpha: 0.76, detail: 0.65 },
    { svg: WOODLAND_BACKDROPS.meadow.near, shape: 'ridge', color: 0x101e2d, speed: 0.18, height: 160, alpha: 0.9, detail: 0.8 },
  ],
  fog: { color: 0x59677f, bands: 2, alphaMin: 0.03, alphaMax: 0.07, driftPx: 34, periodMinMs: 16000, periodMaxMs: 26000, yMin: 0.62, yMax: 0.86, sizeMin: 220, sizeMax: 420 },
  closer: {
    vignette: { color: 0x030711, edgeAlpha: 0.3, washColor: 0x111827, washAlpha: 0.04 },
    grade: { top: 0x4d5f83, bottom: 0x1b2937, strength: 0.14, bands: 4, blend: 'normal' },
  },
});
